var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"networking",attrs:{"id":"networking"}},[_c('iframe',{staticClass:"networking__iframe",attrs:{"src":_vm.link,"frameborder":"0","allow":"camera; microphone","allowTransparency":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }